<template>
  <myhead @next="next">{{ $route.query.title || $route.meta.title}}</myhead>
  <div class="complaint-up flex">
    <img :src="accident.thumb" :onerror="Imgerror">
    <div class="complaint-up-r">
      <p class="size16 weight">{{ accident.name }}</p>
      <p class="size14">{{ accident.spec_key_name }}</p>
      <p class="size14">{{ accident.order_msg  }}</p>
    </div>
  </div>
  <div class="complaint-bottom">
    <p class="size16 b500">一、您遇到了什么类型的问题？</p>
    <p class="size14 complaint-bottom-why">{{ accident.question }}</p>
    <p class="size16 b500">二、上传诉呈</p>
    <img :src="accident.complaint" :onerror="Imgerror" class="complaint-bottom__img">
  </div>
</template>
<script>
import ajax from "@/utils/request.js";
export default {
  data () {
    return {
      accident: {}
    }
  },
  methods: {
    next () {
      history.forward()
    }
  },
  created () {
    if (this.$route.query.type && this.$route.query.type == 'order') {
      ajax.post("accident/appeal", { order_id: this.$route.query.order_id }).then(res => {
        this.accident = res.data
      })
    } else {
      ajax.post("accident/appeal", { order_id: this.$route.query.order_id }).then(res => {
        this.accident = res.data

      })
    }

  }
}
</script>
<style lang="scss">
.complaint-up {
    padding: 3.2vw 4vw;
    align-items: flex-start;
    background-color: #fff;
    margin-bottom: 2.6667vw;
    img {
        border-radius: 1.0667vw;
        width: 26.6667vw;
        height: 26.6667vw;
    }
    .complaint-up-r {
        padding-left: 2.6667vw;
        p {
            &:nth-child(2) {
                color: #999999;
                margin-top: 2.6667vw;
                margin-bottom: 2.6667vw;
            }
            &:last-child {
                color: #3F7C93;
            }
        }
    }
}
.complaint-bottom {
    padding: 2.6667vw 4vw;
    background-color: #fff;
    .complaint-bottom-why {
        color: #666666;
        margin-top: 2.6667vw;
        margin-bottom: 5.3333vw;
    }
    .complaint-bottom__img {
        display: block;
        width: 100%;
        margin-top: 2.6667vw;
    }
}
</style>